module.exports = __webpack_public_path__ + "prod/1.42.2/img/tuniu-icon.5fd0d564.png";